import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

type ITabItemCountModule = 'user' | 'timesheet' | 'task' | 'job' | 'time_off';

const fetchTabItemCountByModule = (module: ITabItemCountModule) => {
  const newEndpoints = endpoints.countByModule.replace('{moduleName}', module);
  return http().get(newEndpoints);
};

export function useFetchTabItemCountByModule(module: ITabItemCountModule): UseQueryResult<any> {
  return useQuery({
    queryKey: ['fetchTabItemCountByModule', module],
    queryFn: () => fetchTabItemCountByModule(module),
  });
}
